// Helper function to convert a file to base64
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const fullBase64 = reader.result?.toString() ?? '';
      const base64Data = fullBase64.substring(fullBase64.indexOf(',') + 1);
      resolve(base64Data);
    };
    reader.onerror = (error) => reject(error);
  });
}
